import React, { useState } from 'react';
import TermsAndConditions from './TermsAndConditions'; // Импортируем новый компонент

const BuySellUSDTForm = ({ handleSubmit, setCurrentView }) => {
    const [usdtSubForm, setUsdtSubForm] = useState('buy'); // 'buy' or 'sell', default to 'buy'
    const [termsAccepted, setTermsAccepted] = useState(false);

    const handleTabClick = (tabName) => {
        setUsdtSubForm(tabName);
        setTermsAccepted(false); // Сбрасываем чекбокс при смене вкладки
    };

    return (
        <div id="buySellUSDTForm" className="form-container">
            <div className="tabs">
                <button onClick={() => handleTabClick('buy')} className={usdtSubForm === 'buy' ? 'active' : ''}>Купить USDT</button>
                <button onClick={() => handleTabClick('sell')} className={usdtSubForm === 'sell' ? 'active' : ''}>Продать USDT</button>
            </div>

            {usdtSubForm === 'buy' && (
                <form onSubmit={(e) => handleSubmit(e, 'buyUSDT')}>
                    <label htmlFor="buyAmountRub">Введите сумму в рублях:</label>
                    <input type="number" id="buyAmountRub" name="amountRub" required />

                    <label htmlFor="buyBank">С какого банка оплата:</label>
                    <input type="text" id="buyBank" name="bank" required />

                    <label htmlFor="buySenderName">ФИО отправителя в банке:</label>
                    <input type="text" id="buySenderName" name="senderName" required />

                    <label htmlFor="buyTelegram">Телеграм для связи:</label>
                    <input type="text" id="buyTelegram" name="telegram" required />

                    <TermsAndConditions
                        isChecked={termsAccepted}
                        onCheckboxChange={() => setTermsAccepted(!termsAccepted)}
                        onShowRules={() => setCurrentView('rules', 'buySellUSDT')} // Передаем текущий view для возврата
                    />
                    <button type="submit" disabled={!termsAccepted}>Отправить заявку</button>
                    <button type="button" className="back-to-main-menu-button" onClick={() => { setCurrentView('mainMenu'); setTermsAccepted(false); }}>Назад в главное меню</button>
                    {/* Кнопка "Назад" внутри формы больше не нужна, т.к. есть вкладки и "Назад в главное меню" */}
                </form>
            )}

            {usdtSubForm === 'sell' && (
                <form onSubmit={(e) => handleSubmit(e, 'sellUSDT')}>
                    <label htmlFor="sellAmountRub">Введите сумму в рублях, которую желаете получить:</label>
                    <input type="number" id="sellAmountRub" name="amountRub" required />

                    <label htmlFor="sellReceiverName">ФИО получателя:</label>
                    <input type="text" id="sellReceiverName" name="receiverName" required />

                    <label htmlFor="sellTelegram">Телеграм для связи:</label>
                    <input type="text" id="sellTelegram" name="telegram" required />

                    <TermsAndConditions
                        isChecked={termsAccepted}
                        onCheckboxChange={() => setTermsAccepted(!termsAccepted)}
                        onShowRules={() => setCurrentView('rules', 'buySellUSDT')} // Передаем текущий view для возврата
                    />
                    <button type="submit" disabled={!termsAccepted}>Отправить заявку</button>
                    <button type="button" className="back-to-main-menu-button" onClick={() => { setCurrentView('mainMenu'); setTermsAccepted(false); }}>Назад в главное меню</button>
                     {/* Кнопка "Назад" внутри формы больше не нужна, т.к. есть вкладки и "Назад в главное меню" */}
                </form>
            )}
            
        </div>
    );
};

export default BuySellUSDTForm;